module.exports = __webpack_public_path__ + "static/media/van.2ffdcd87.svg";